import React from 'react';
import {useHealth} from '../context/HealthContext';

/**
 * Fixed top-of-viewport banner shown only while the API is affirmatively down.
 * Rendered once at the app root so it overlays every route. When visible, the
 * pages also disable login/subscribe/unsubscribe actions (they read the same
 * useHealth() state), so this banner explains why those controls are inert.
 */
export default function HealthBanner(): React.ReactElement | null {
  const {isDown, refresh} = useHealth();

  if (!isDown) {
    return null;
  }

  return (
    <div
      role="alert"
      aria-live="assertive"
      className="fixed top-0 inset-x-0 z-50 bg-red-700 text-white shadow-md"
    >
      <div className="max-w-screen-xl mx-auto px-6 py-2.5 flex items-center justify-center gap-3 text-sm">
        <span className="font-semibold">Service temporarily unavailable.</span>
        <span className="text-red-100">
          We can&rsquo;t reach the portal service right now — sign-in and subscription changes are
          paused. The list below may be out of date.
        </span>
        <button
          onClick={refresh}
          className="ml-2 shrink-0 rounded border border-red-300/60 px-2.5 py-0.5 text-xs font-medium hover:bg-red-600 transition-colors"
        >
          Retry
        </button>
      </div>
    </div>
  );
}
